import React from 'react'

import { ZariContext } from '_zari/context'
import { Form, Col } from '_zari/core'

import { TiposDeDocumentosRelacionadosCuentaContableConstant } from 'constants/index'

import * as AsientosContablesService from 'services/asientosContables.service'

const Cuenta12FormGroup = ({ idSocio, consultado, setConsultado, onChange, value }) => {
  const __zariContext = React.useContext(ZariContext)

  const [cuentasContables, setCuentasContables] = React.useState([])

  React.useEffect(() => {
    if (idSocio) {
      setConsultado(false)
      __zariContext.loader.open('Consultando cuentas pendientes')
      AsientosContablesService.obtenerCuentasUtilizadasxFiltros(idSocio, TiposDeDocumentosRelacionadosCuentaContableConstant.DOCUMENTOS_VARIOS)
        .then(({ data }) => {
          setCuentasContables(data)
        })
        .catch(() => {
          setCuentasContables([])
        })
        .finally(() => {
          setConsultado(true)
          __zariContext.loader.close()
        })
    }
  }, [__zariContext.loader, idSocio, setConsultado])

  return (
    <Form.Group>
      <Form.Label text='CUENTA CONTABLE' htmlFor='select-cuentaContable' md={4} alignRightAt='md' />
      <Col md={8}>
        <Form.Select
          value={value}
          onChange={e => onChange(e.target.value)}
          id='select-cuentaContable'
          name='select-cuentaContable'
          disabled={!consultado}
        >
          <option value=''>Seleccionar</option>
          {cuentasContables.map(x => (
            <option key={x.cuentaContable} value={x.cuentaContable}>
              {`${x.cuentaContable} - ${x.descripcion}`}
            </option>
          ))}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default React.memo(Cuenta12FormGroup)
